import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.232.576A6.24 6.24 0 0 0 0 6.808v8.629a6.24 6.24 0 0 0 6.232 6.232h8.629a6.24 6.24 0 0 0 6.232-6.232v-8.63A6.24 6.24 0 0 0 14.86.577H6.232Zm0 .959h8.629a5.266 5.266 0 0 1 5.273 5.273v8.629a5.266 5.266 0 0 1-5.273 5.273H6.232a5.266 5.266 0 0 1-5.273-5.273v-8.63a5.266 5.266 0 0 1 5.273-5.272ZM16.299 4.41a.959.959 0 1 0 0 1.918.959.959 0 0 0 0-1.918Zm-5.753 1.438a5.28 5.28 0 0 0-5.273 5.273 5.28 5.28 0 0 0 5.273 5.273 5.28 5.28 0 0 0 5.274-5.273 5.28 5.28 0 0 0-5.274-5.273Zm0 .959a4.307 4.307 0 0 1 4.315 4.314 4.307 4.307 0 0 1-4.315 4.315 4.307 4.307 0 0 1-4.314-4.315 4.307 4.307 0 0 1 4.314-4.314Z",
      fill: "#FBBA00"
    }, null, -1)
  ]))]))
}
export default { render: render }